export type GameBackHandler = () => boolean;

type HandlerEntry = {
  id: number;
  handler: GameBackHandler;
  priority: number;
};

declare global {
  interface Window {
    __APK_GAMES_HANDLE_BACK__?: GameBackHandler;
  }
}

const ROOT_STATE_KEY = "__apkGamesBackRoot";
const SENTINEL_STATE_KEY = "__apkGamesBackSentinel";
const bridgeId = `apk-games-${Date.now()}-${Math.random().toString(36).slice(2)}`;
const handlers: HandlerEntry[] = [];
let nextHandlerId = 1;
let browserBridgeInstalled = false;
let forwardingToBrowser = false;

function invokeGameBackHandlers() {
  const ordered = [...handlers].sort((left, right) => right.priority - left.priority || right.id - left.id);
  for (const entry of ordered) {
    try {
      if (entry.handler()) return true;
    } catch (error) {
      console.warn("Game back handler failed", error);
    }
  }
  return false;
}

function armBrowserBackBridge() {
  if (typeof window === "undefined" || browserBridgeInstalled) return;
  browserBridgeInstalled = true;
  window.__APK_GAMES_HANDLE_BACK__ = invokeGameBackHandlers;

  const currentState = window.history.state && typeof window.history.state === "object"
    ? window.history.state as Record<string, unknown>
    : {};
  if (currentState[SENTINEL_STATE_KEY] === bridgeId) return;

  window.history.replaceState({ ...currentState, [ROOT_STATE_KEY]: bridgeId }, "", window.location.href);
  window.history.pushState({ ...currentState, [SENTINEL_STATE_KEY]: bridgeId }, "", window.location.href);
  window.addEventListener("popstate", () => {
    if (forwardingToBrowser) return;
    if (invokeGameBackHandlers()) {
      window.history.pushState({ ...window.history.state, [SENTINEL_STATE_KEY]: bridgeId }, "", window.location.href);
      return;
    }

    // 页面已经回到游戏根层时，把这次返回继续交给浏览器/系统，避免把用户困在游戏里。
    forwardingToBrowser = true;
    window.history.back();
  });
}

/**
 * 注册一个返回处理器。后注册的处理器优先，适合让局部弹层覆盖页面级处理器。
 * 不监听 touch/pointer，因此不会抢占地图、轮播和横向列表手势。
 */
export function registerGameBackHandler(handler: GameBackHandler, priority = 0) {
  const entry = { id: nextHandlerId, handler, priority };
  nextHandlerId += 1;
  handlers.push(entry);
  armBrowserBackBridge();

  return () => {
    const index = handlers.findIndex((item) => item.id === entry.id);
    if (index >= 0) handlers.splice(index, 1);
  };
}
